import { Button, Form, Modal } from "antd";
import { observer } from "mobx-react-lite";
import React, { useEffect, useMemo, useRef } from "react";
import { TicketMetaFormField } from "../../../../_shared/types/TicketMeta";
import { useFieldConfig } from "../../../hooks/useFieldConfig";
import { MetaFieldInput } from "./MetaFieldInput";

type Props = {
  onChange?: (value: TicketMetaFormField) => void;
  value?: TicketMetaFormField;
  open?: boolean;
  setOpen?: React.Dispatch<React.SetStateAction<boolean>>;
};

export const MetaModal = observer((props: Props) => {
  const config = useFieldConfig("meta");
  const fields = config?.fields || [];
  const [form] = Form.useForm();

  const metaFields = useMemo(
    () =>
      fields.map((field) => <MetaFieldInput key={field.label} field={field} />),
    [config]
  );

  // the modal cant trigger the submit button, so we need to use a ref to trigger it
  const ref = useRef<HTMLButtonElement>(null);

  function handleOk(values: TicketMetaFormField) {
    props.onChange?.(values);
    props.setOpen?.(false);
  }

  useEffect(() => {
    if (props.value && form) form.setFieldsValue(props.value);
  }, [props.value, form]);

  return (
    <Modal
      forceRender
      title="Metadaten festlegen"
      open={props.open}
      width={600}
      onCancel={() => props.setOpen?.(false)}
      // onClose={() => props.setOpen?.(false)}
      onOk={() => ref?.current?.click()}
    >
      <Form
        onFinish={handleOk}
        form={form}
        layout="vertical"
        initialValues={props.value}
      >
        {metaFields}
        <Button htmlType="submit" hidden ref={ref} />
      </Form>
    </Modal>
  );
});
